import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ScreenHeader, StatusPill } from '../styles';

interface EcoSimplifiedStatusHeaderProps {
  online: boolean;
}

/** Selo de conexão do DAM no topo da tela do Modo Eco simplificado, como no design. */
export function EcoSimplifiedStatusHeader({ online }: Readonly<EcoSimplifiedStatusHeaderProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <ScreenHeader>
      <StatusPill $online={online} data-testid="eco-simplificado-status">
        {online ? t('online') : t('offline')}
      </StatusPill>
    </ScreenHeader>
  );
}
